import { defineStore } from 'pinia'
import { resolveRegionId } from '../constants'

export const useClientStore = defineStore('client', {
  state: () => ({
    client: null, // Agora armazena um Seller (cliente web)
    token: null,
    isAuthenticated: false,
    initialized: false
  }),

  getters: {
    // Para compatibilidade, retorna o Id do seller como clientId
    clientId: (state) => state.client?.id,
    // Retorna o sellerId (mesmo que clientId, mas usando nomenclatura do sistema)
    sellerId: (state) => state.client?.id,
    clientName: (state) => state.client?.name,
    clientUsername: (state) => state.client?.login || state.client?.username,
    regionId: (state) => resolveRegionId(state.client?.regionId, state.client?.RegionId),
    // Retorna o saldo da carteira
    walletBalance: (state) => parseFloat(state.client?.walletBalance || 0),
    walletLimit: (state) => parseFloat(state.client?.walletLimit || 0)
  },

  actions: {
    login(seller, token) {
      // seller é um SellerLoginResponse ou SellerResponse
      this.client = seller
      this.token = token
      this.isAuthenticated = true
      
      localStorage.setItem('client', JSON.stringify(seller))
      localStorage.setItem('clientToken', token)
      const regionId = resolveRegionId(seller?.regionId, seller?.RegionId)
      if (regionId) localStorage.setItem('regionId', regionId)
    },

    logout() {
      this.client = null
      this.token = null
      this.isAuthenticated = false
      
      localStorage.removeItem('client')
      localStorage.removeItem('clientToken')
      localStorage.removeItem('regionId')
    },

    initialize() {
      if (this.initialized) return
      
      const client = localStorage.getItem('client')
      const token = localStorage.getItem('clientToken')
      
      if (client && token) {
        try {
          this.client = JSON.parse(client)
          this.token = token
          this.isAuthenticated = true
        } catch (e) {
          console.error('Erro ao inicializar client store:', e)
        }
      }
      
      this.initialized = true
    },
    
    // Atualizar saldo da carteira
    updateWalletBalance(walletBalance, walletLimit = null) {
      if (this.client) {
        this.client.walletBalance = parseFloat(walletBalance || 0)
        if (walletLimit !== null) {
          this.client.walletLimit = parseFloat(walletLimit || 0)
        }
        localStorage.setItem('client', JSON.stringify(this.client))
        
        // Disparar evento para atualizar componentes
        window.dispatchEvent(new CustomEvent('wallet-updated'))
      }
    }
  }
})


